import React from 'react';
import {
	TextInput,
	required,
	useTranslate,
	useNotify,
	useCreate,
} from 'react-admin';
import IconLock from '@material-ui/icons/Lock';
import IconUnlock from '@material-ui/icons/LockOpen';
import BaseDialog from '../../components/dialog/BaseDialog';
import { Form } from 'react-final-form';

const LockWalletAccount = ({ record, version }) => {
	const translate = useTranslate();
	const notify = useNotify();
	const [lockOrUnlockWalletAccount] = useCreate('walletAccounts');

	const handleSubmit = (values, hideDialog) => {
		const method = record.accountStatus === 'Locked' ? 'unlock' : 'lock';
		const notification = record.accountStatus === 'Locked'
				? 'resources.walletAccounts.notifications.successfullyUnlocked'
				: 'resources.walletAccounts.notifications.successfullyLocked';
		lockOrUnlockWalletAccount(
			{
				payload: {
					id: record.id,
					data: values,
					method,
				}
			},
			{
				onSuccess: () => {
					notify(notification, 'info');
					hideDialog();
				},
				onFailure: (error) => {
					notify(error.message, 'error');
				}
			},
		);
	};

	return (
		<BaseDialog
			icon={record.accountStatus === 'Deleted' ? <IconUnlock /> : <IconLock />}
			buttonDisabled={record.accountStatus === 'Deleted'}
			buttonLabel={translate(record.accountStatus === 'Locked' ? 'resources.walletAccounts.labels.unlock' : 'resources.walletAccounts.labels.lock')}
			dialogTitle={translate(record.accountStatus === 'Locked' ? 'resources.walletAccounts.labels.unlock' : 'resources.walletAccounts.labels.lock')}
			handleSubmit={handleSubmit}
		>
			{({ handleSubmit, hideDialog }) => (
				<Form
					initialValues={{
						description: '',
					}}
					onSubmit={values => handleSubmit(values, hideDialog)}
					key={version}
					keepDirtyOnReinitialize
					render={({ handleSubmit }) => (
						<form onSubmit={handleSubmit}>
							<TextInput source="description" validate={required()} fullWidth resettable multiline />
							</form>
					)}
				/>
			)}
		</BaseDialog>
	);

};

export default LockWalletAccount;
